import { render, staticRenderFns } from "./stationmasterList.vue?vue&type=template&id=52637d8d&scoped=true&"
import script from "./stationmasterList.vue?vue&type=script&lang=js&"
export * from "./stationmasterList.vue?vue&type=script&lang=js&"
import style0 from "./stationmasterList.vue?vue&type=style&index=0&id=52637d8d&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52637d8d",
  null
  
)

export default component.exports